'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { H2, H4 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { useSearchParams } from 'next/navigation';
import { cn } from '@/app/_lib/utils';
import { JobOfferStatusBadge } from '../../_components/JobOfferStatusBadge';
import type { JobOfferListItem } from '../../_data/types';
export function JobOfferList(t0) {
  const $ = _c(11);
  const {
    jobOfferList
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("oferta");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentSlug = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-6 text-center lg:text-left"><H2>Oferty pracy</H2></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== currentSlug || $[4] !== jobOfferList) {
    let t4;
    if ($[6] !== currentSlug || $[7] !== jobOfferList[0]) {
      t4 = jobOffer => {
        const isSelected = currentSlug === jobOffer.slug || !currentSlug && jobOffer === jobOfferList[0];
        return <Link key={jobOffer.slug} href={`/kariera?oferta=${jobOffer.slug}`} className="block"><LightCard className={cn("cursor-pointer p-6", isSelected && "outline-2 outline-algoprimary")}><div className="flex flex-row flex-wrap items-start justify-between gap-2"><H4>{jobOffer.positionName}</H4><JobOfferStatusBadge isActive={jobOffer.isActive} /></div><div className="h-2" /><p className="text-slate-600 text-sm">{jobOffer.description}</p><p className="mt-4 font-semibold text-algoprimary text-sm lg:hidden">Czytaj więcej</p></LightCard></Link>;
      };
      $[6] = currentSlug;
      $[7] = jobOfferList[0];
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = jobOfferList.map(t4);
    $[3] = currentSlug;
    $[4] = jobOfferList;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="w-full space-y-6 lg:flex lg:flex-col">{t2}<section className="flex flex-col gap-4" aria-label="Lista ofert pracy">{t3}</section></div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}